import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import { AssignmentPriority } from "@/api";

export function AssignmentPriorityIndicator({ priority }: { priority: AssignmentPriority }) {
  if (priority !== AssignmentPriority.High) {
    return null;
  }

  return (
    <PriorityHighIcon
      sx={{
        fontSize: 14,
        color: (theme) => theme.palette.fsw["oragen-wcag"],
        mr: 0.25,
        p: 0,
        verticalAlign: "middle",
      }}
    />
  );
}
